var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPictureInPicture = function SvgIconPictureInPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 19.75A1.75 1.75 0 0 1 2 18V6c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75v12a1.75 1.75 0 0 1-1.75 1.75zm.25-2V6.25h16V11h-6.5a1.75 1.75 0 0 0-1.75 1.75v5zM20 13v4.75h-6.25V13z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPictureInPicture;